module.exports = __webpack_public_path__ + "img/企业信用.0c6958d8.jpg";